
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import Assignee from './Assignee';

// Utils

import { sortByNameInAlphabeticalOrder } from '@utils/miscellaneous/sortings';


const AssigneesList = props => {
    const {
        assignees,
        changeCurrentAssignee
    } = props;

    const wrapWithBubble = value =>
        React.createElement(
            'div',
            { key: value, className: 'assignee-attribute' },
            value
        );

    const getInlineList = values => {
        switch(true){
            case values.length === 0:
                return '-';
            case values.length === 1:
                return wrapWithBubble(values[0].name);
            default:
                return values.map(({ name }) => wrapWithBubble(name));
        }
    };

    const columns = [
        {
            prop: ['name', 'email']
        },
        {
            prop: 'workgroups',
            func: workgroups => getInlineList(sortByNameInAlphabeticalOrder(workgroups))
        },
        {
            prop: 'tags',
            func: tags => getInlineList(sortByNameInAlphabeticalOrder(tags))
        }
    ];

    const getHeader = () => {
        return columns.map(column => {
            const { prop } = column;
            const getHeaderContent = () => {
                if(Array.isArray(prop)) {
                    const [ prop1, prop2 ] = prop;
                    return (
                        <Fragment>
                            <FormattedMessage id = { `assignees.table.cell.${ prop1 }` }/> &nbsp;
                            (<FormattedMessage id = { `assignees.table.cell.${ prop2 }` }/>)
                        </Fragment>
                    );
                } else {
                    return <FormattedMessage id = { `assignees.table.cell.${ prop }` }/>;
                }
            };

            return (
                <div key = { prop } className = 'text-capitalize desktop:grid-col-4'>
                    { getHeaderContent() }
                </div>
            );
        });
    };

    const getAssignees = () => {
        return sortByNameInAlphabeticalOrder(assignees).map(assignee => {
            const { id } = assignee;
            return (
                <div
                    className = 'assignee-row grid-row'
                    key = { id }
                    onClick = { () => changeCurrentAssignee(id) }
                >
                    <Assignee
                        { ...{
                            assignee,
                            columns
                        } }
                    />
                </div>
            );
        });
    };

    const getAssigneesList = () => {
        return (
            <div>
                <div className = 'grid-row'>
                    { getHeader() }
                </div>
                <hr className = 'height-2px'/>
                <div>
                    { getAssignees() }
                </div>
            </div>
        );
    };

    return (
        assignees.length ?
            <div className = 'assignee-section gi-panel'>
                { getAssigneesList() }
            </div> :
            null
    );
};

export default AssigneesList;
